// ========================================================
// FAST HIT Website — Feature Cards Section
// 6 Core Sports-Tech Capabilities
// ========================================================

import { Link } from 'react-router-dom';
import {
  Zap,
  BarChart3,
  Users2,
  Trophy,
  ShieldCheck,
  Compass,
  ArrowRight,
} from 'lucide-react';
import './FeatureCards.css';

const FEATURES = [
  {
    icon: Zap,
    title: 'Live Ball-by-Ball Scoring',
    description:
      'Record runs, extras, boundaries, dismissals, and maiden overs in seconds. Instant synchronization across mobile and web.',
    badge: 'Real-Time Sync',
    link: '/features',
    color: 'var(--color-primary)',
  },
  {
    icon: BarChart3,
    title: 'Deep Player Analytics',
    description:
      'Career stats, strike rates, batting/bowling averages, recent form graphs, boundary ratios, and verified digital player cards.',
    badge: 'Pro Stats',
    link: '/players',
    color: 'var(--color-cyan)',
  },
  {
    icon: Users2,
    title: 'Squad & Team Management',
    description:
      'Manage club rosters, captain/vice-captain roles, playing XI selections, and track head-to-head match histories.',
    badge: 'Club Hub',
    link: '/teams',
    color: '#a78bfa',
  },
  {
    icon: Trophy,
    title: 'Tournaments & Auto-Standings',
    description:
      'Organize league tables, knockout brackets, automated Net Run Rate (NRR) calculations, and tournament top-performer rankings.',
    badge: 'Automated NRR',
    link: '/tournaments',
    color: '#f59e0b',
  },
  {
    icon: ShieldCheck,
    title: 'Authorized Official Scoring',
    description:
      'Role-based permissions ensure that only assigned match scorers and umpires submit official delivery events, preventing tampering.',
    badge: 'Fair Play',
    link: '/features',
    color: '#10b981',
  },
  {
    icon: Compass,
    title: 'Cricket Discovery & Community',
    description:
      'Discover local cricket tournaments, find nearby grounds, follow exciting matches, and connect with cricket enthusiasts.',
    badge: 'Discovery',
    link: '/live-scores',
    color: '#ec4899',
  },
];

export function FeatureCards() {
  return (
    <section className="features-sec" aria-labelledby="features-title">
      <div className="features-sec__container">
        {/* Header */}
        <div className="features-sec__header text-center">
          <div className="section-eyebrow">
            <Zap size={14} className="text-cyan" />
            <span>Built for Modern Cricket</span>
          </div>
          <h2 id="features-title" className="section-title">
            Engineered for Players, Captains & Organizers
          </h2>
          <p className="section-subtitle mx-auto">
            Everything you need to run competitive matches, celebrate cricket achievements, and keep fans engaged.
          </p>
        </div>

        {/* Features Grid */}
        <div className="features-sec__grid">
          {FEATURES.map((feat) => {
            const Icon = feat.icon;
            return (
              <div key={feat.title} className="feature-card card card--interactive">
                <div className="feature-card__top">
                  <div
                    className="feature-card__icon-box"
                    style={{ background: `color-mix(in srgb, ${feat.color} 15%, transparent)`, color: feat.color }}
                  >
                    <Icon size={24} />
                  </div>
                  <span className="feature-card__badge">{feat.badge}</span>
                </div>

                <h3 className="feature-card__title">{feat.title}</h3>
                <p className="feature-card__desc">{feat.description}</p>

                <Link to={feat.link} className="feature-card__link">
                  <span>Explore Feature</span>
                  <ArrowRight size={14} />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
